/* Gymspiderr — Botón con brillo especular (adaptado de React Bits "SpecularButton" a JS sin React).
   - Botón propio: <a class="gym-specular" data-...><canvas class="gym-specular__light"></canvas><span class="gym-specular__label">Texto</span></a>
   - Botones del tema (Agregar al carrito, Comprar ahora, Seleccionar opciones, Ver todo): se les agrega el brillo
     automáticamente, respetando su color (en botones blancos/transparentes el brillo toma el color del texto).
   Usa un solo contexto WebGL compartido para que funcione con muchos botones a la vez. */
(function () {
  if (window.__gymSpecularLoaded) return;
  window.__gymSpecularLoaded = true;

  var PAD = 24;
  var TAU = Math.PI * 2;

  // Botones del tema que reciben el efecto automáticamente
  var AUTO_TARGETS = [
    { selector: '.product-form__submit', auto: 'touch' },
    { selector: '.shopify-payment-button__button--unbranded', auto: 'touch' },
    { selector: '.quick-add__submit', auto: 'false' },
    { selector: '.collection__view-all a.button', auto: 'touch' }
  ];

  var VERTEX = '#version 300 es\n' +
    'in vec2 aPosition;\n' +
    'void main() {\n' +
    '  gl_Position = vec4(aPosition, 0.0, 1.0);\n' +
    '}';

  var FRAGMENT = '#version 300 es\n' +
    'precision highp float;\n' +
    'uniform vec2 uCenter;\n' +
    'uniform vec2 uHalf;\n' +
    'uniform float uRadius;\n' +
    'uniform float uPx;\n' +
    'uniform float uSpot;\n' +
    'uniform vec2 uEntry;\n' +
    'uniform vec3 uLineColor;\n' +
    'uniform vec3 uBaseColor;\n' +
    'uniform float uIntensity;\n' +
    'uniform vec2 uWindow;\n' +
    'uniform float uThickness;\n' +
    'uniform float uGlow;\n' +
    'out vec4 outColor;\n' +
    'float roundedBox(vec2 p, vec2 b, float r) {\n' +
    '  vec2 q = abs(p) - b + r;\n' +
    '  return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;\n' +
    '}\n' +
    'float loopPosition(vec2 p, vec2 b, float r) {\n' +
    '  vec2 inner = b - r;\n' +
    '  float arc = 1.5707963 * r;\n' +
    '  float quarter = inner.x + inner.y + arc;\n' +
    '  vec2 a = abs(p);\n' +
    '  vec2 q = a - inner;\n' +
    '  float s = q.x > 0.0 && q.y > 0.0\n' +
    '    ? inner.y + atan(q.y, q.x) * r\n' +
    '    : (q.x > q.y ? min(a.y, inner.y) : inner.y + arc + inner.x - min(a.x, inner.x));\n' +
    '  if (p.x < 0.0) s = p.y >= 0.0 ? 2.0 * quarter - s : 2.0 * quarter + s;\n' +
    '  else if (p.y < 0.0) s = 4.0 * quarter - s;\n' +
    '  return s / max(4.0 * quarter, 0.0001);\n' +
    '}\n' +
    'float lobe(float position, float center) {\n' +
    '  float gap = abs(fract(position - center + 0.5) - 0.5);\n' +
    '  return 1.0 - smoothstep(uWindow.x, uWindow.x + uWindow.y, gap);\n' +
    '}\n' +
    'void main() {\n' +
    '  vec2 p = gl_FragCoord.xy - uCenter;\n' +
    '  float d = roundedBox(p, uHalf, uRadius);\n' +
    '  float position = loopPosition(p, uHalf, uRadius);\n' +
    '  float key = lobe(position, uSpot);\n' +
    '  float back = lobe(position, uSpot + 0.5);\n' +
    '  float streak = key + back * 0.45;\n' +
    '  float width = max(uThickness * uPx * mix(1.0, max(key, back), 0.6), 0.35);\n' +
    '  float band = smoothstep(-width - 0.6, -width + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));\n' +
    '  float hair = smoothstep(-uPx - 0.6, -uPx + 0.6, d) * (1.0 - smoothstep(-0.6, 0.6, d));\n' +
    '  float inside = 1.0 - smoothstep(-0.6, 0.6, d);\n' +
    '  vec2 pool = (p - uEntry) / (uHalf.y * vec2(1.6, 1.1));\n' +
    '  float glow = streak * 0.2 * exp(-abs(d + width * 0.5) / (5.0 * uPx)) + inside * 0.08 * exp(-dot(pool, pool));\n' +
    '  float light = clamp((band * streak + glow * uGlow) * uIntensity, 0.0, 1.0);\n' +
    '  vec4 base = vec4(uBaseColor, 1.0) * hair * 0.6;\n' +
    '  outColor = vec4(uLineColor, 1.0) * light + base * (1.0 - light);\n' +
    '}';

  var UNIFORMS = ['uCenter', 'uHalf', 'uRadius', 'uPx', 'uSpot', 'uEntry', 'uLineColor', 'uBaseColor', 'uIntensity', 'uWindow', 'uThickness', 'uGlow'];

  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function wrap(value) { return value - Math.floor(value); }

  function loopPosition(x, y, halfX, halfY, r) {
    var innerX = halfX - r, innerY = halfY - r;
    var arc = (Math.PI / 2) * r;
    var quarter = innerX + innerY + arc;
    var ax = Math.abs(x), ay = Math.abs(y);
    var qx = ax - innerX, qy = ay - innerY;
    var s;
    if (qx > 0 && qy > 0) s = innerY + Math.atan2(qy, qx) * r;
    else if (qx > qy) s = Math.min(ay, innerY);
    else s = innerY + arc + innerX - Math.min(ax, innerX);
    if (x < 0) s = y >= 0 ? 2 * quarter - s : 2 * quarter + s;
    else if (y < 0) s = 4 * quarter - s;
    return wrap(s / Math.max(4 * quarter, 0.0001));
  }

  function rimPoint(position, halfX, halfY, r) {
    var innerX = halfX - r, innerY = halfY - r;
    var arc = (Math.PI / 2) * r;
    var quarter = innerX + innerY + arc;
    var s = wrap(position) * 4 * quarter;
    var signX = 1, signY = 1;
    if (s > 3 * quarter) { s = 4 * quarter - s; signY = -1; }
    else if (s > 2 * quarter) { s -= 2 * quarter; signX = -1; signY = -1; }
    else if (s > quarter) { s = 2 * quarter - s; signX = -1; }
    var x = innerX - (s - innerY - arc);
    var y = halfY;
    if (s <= innerY) { x = halfX; y = s; }
    else if (s <= innerY + arc) {
      var angle = (s - innerY) / Math.max(r, 0.0001);
      x = innerX + Math.cos(angle) * r;
      y = innerY + Math.sin(angle) * r;
    }
    return [x * signX, y * signY];
  }

  function compile(gl, type, source) {
    var shader = gl.createShader(type);
    if (!shader) return null;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return shader;
    gl.deleteShader(shader);
    return null;
  }

  function link(gl) {
    var vertex = compile(gl, gl.VERTEX_SHADER, VERTEX);
    var fragment = compile(gl, gl.FRAGMENT_SHADER, FRAGMENT);
    var program = gl.createProgram();
    if (!vertex || !fragment || !program) return null;
    gl.attachShader(program, vertex);
    gl.attachShader(program, fragment);
    gl.bindAttribLocation(program, 0, 'aPosition');
    gl.linkProgram(program);
    gl.deleteShader(vertex);
    gl.deleteShader(fragment);
    if (gl.getProgramParameter(program, gl.LINK_STATUS)) return program;
    gl.deleteProgram(program);
    return null;
  }

  /* ---------- Renderizador WebGL compartido ---------- */
  var renderer = null;
  function getRenderer() {
    if (renderer !== null) return renderer;
    renderer = false;
    var glCanvas = document.createElement('canvas');
    var gl = glCanvas.getContext('webgl2', { alpha: true, premultipliedAlpha: true, antialias: false, depth: false, stencil: false });
    if (!gl) return renderer;
    var program = link(gl);
    if (!program) return renderer;
    var uniforms = {};
    UNIFORMS.forEach(function (name) { uniforms[name] = gl.getUniformLocation(program, name); });
    var buffer = gl.createBuffer();
    var vao = gl.createVertexArray();
    gl.bindVertexArray(vao);
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(0);
    gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
    gl.bindVertexArray(null);
    renderer = { canvas: glCanvas, gl: gl, program: program, uniforms: uniforms, vao: vao };
    return renderer;
  }

  /* ---------- Colores ---------- */
  var probe = document.createElement('canvas').getContext('2d', { willReadFrequently: true });
  var colorCache = {};
  function toRgb(value) {
    if (colorCache[value]) return colorCache[value];
    var rgb = [1, 1, 1];
    if (probe) {
      probe.clearRect(0, 0, 1, 1);
      probe.fillStyle = '#000000';
      probe.fillStyle = value;
      probe.fillRect(0, 0, 1, 1);
      var px = probe.getImageData(0, 0, 1, 1).data;
      rgb = [px[0] / 255, px[1] / 255, px[2] / 255];
    }
    colorCache[value] = rgb;
    return rgb;
  }
  function parseRgba(value) {
    var m = String(value).match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }
  // Botón relleno de color -> brillo blanco. Botón blanco/transparente -> brillo del color del texto.
  function autoLineColor(button) {
    var cs = getComputedStyle(button);
    var bg = parseRgba(cs.backgroundColor);
    var light = !bg || bg.a < 0.3 || (0.299 * bg.r + 0.587 * bg.g + 0.114 * bg.b) > 200;
    return light ? cs.color : '#ffffff';
  }

  /* ---------- Estado global del puntero ---------- */
  var pointer = { x: 0, y: 0, known: false };
  var instances = [];
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  function wakeAll() { for (var i = 0; i < instances.length; i++) instances[i].wake(); }
  window.addEventListener('pointermove', function (e) { pointer.x = e.clientX; pointer.y = e.clientY; pointer.known = true; wakeAll(); }, { passive: true });
  function onPointerEnd(e) { if (e.pointerType === 'mouse') return; pointer.known = false; wakeAll(); }
  window.addEventListener('pointerup', onPointerEnd, { passive: true });
  window.addEventListener('pointercancel', onPointerEnd, { passive: true });
  document.documentElement.addEventListener('pointerleave', function () { pointer.known = false; wakeAll(); });
  window.addEventListener('scroll', function () { if (pointer.known) wakeAll(); }, { passive: true });

  function num(el, name, fallback) {
    var v = parseFloat(el.getAttribute('data-' + name));
    return isNaN(v) ? fallback : v;
  }

  function readSettings(button) {
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var auto = button.getAttribute('data-auto-animate');
    var lineAttr = button.getAttribute('data-line-color');
    var line = !lineAttr || lineAttr === 'auto' ? autoLineColor(button) : lineAttr;
    var baseAttr = button.getAttribute('data-base-color');
    return {
      radius: Math.max(0, parseFloat(getComputedStyle(button).borderTopLeftRadius) || num(button, 'radius', 18)),
      lineColor: line,
      baseColor: !baseAttr || baseAttr === 'auto' ? line : baseAttr,
      intensity: Math.max(0, num(button, 'intensity', 1)),
      idleIntensity: clamp(num(button, 'idle-intensity', 0.45), 0, 1),
      shineSize: Math.max(0, num(button, 'shine-size', 10)),
      shineFade: Math.max(0, num(button, 'shine-fade', 34)),
      thickness: Math.max(0, num(button, 'thickness', 1.4)),
      glow: Math.max(0, num(button, 'glow', 1)),
      speed: num(button, 'speed', 0.6),
      followMouse: button.getAttribute('data-follow-mouse') !== 'false',
      proximity: Math.max(1, num(button, 'proximity', 250)),
      // En celulares no hay mouse: el brillo gira solo para que se luzca
      autoAnimate: auto === 'true' || (auto === 'touch' && touch),
      disabled: !!button.disabled || button.getAttribute('aria-disabled') === 'true'
    };
  }

  function setup(button) {
    if (button.__gymSpecular) return;
    var r = getRenderer();
    if (!r) return;
    button.__gymSpecular = true;
    var canvas = button.querySelector(':scope > .gym-specular__light');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'gym-specular__light';
      canvas.setAttribute('aria-hidden', 'true');
      button.appendChild(canvas);
      button.classList.add('gym-specular-fx');
      if (getComputedStyle(button).position === 'static') button.style.position = 'relative';
    }
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    button.classList.add('gym-specular--ready');

    var view = { width: 1, height: 1, ratio: 1 };
    var state = { spot: 0, level: 0, press: 0, ready: false };
    var settings = readSettings(button);
    var raf = 0, last = 0, visible = false;

    function cornerRadius(s) { return Math.min(s.radius, view.width / 2, view.height / 2); }

    function restSpot(s) {
      var rr = cornerRadius(s);
      var inset = rr * (1 - Math.SQRT1_2);
      return loopPosition(inset - view.width / 2, view.height / 2 - inset, view.width / 2, view.height / 2, rr);
    }

    function aim(s) {
      if (!s.followMouse || s.disabled || !pointer.known) return null;
      var rect = button.getBoundingClientRect();
      var scale = rect.width / view.width || 1;
      var halfX = view.width / 2, halfY = view.height / 2;
      var x = (pointer.x - rect.left - rect.width / 2) / scale;
      var y = (rect.top + rect.height / 2 - pointer.y) / scale;
      var distance = Math.hypot(Math.max(Math.abs(x) - halfX, 0), Math.max(Math.abs(y) - halfY, 0));
      var t = clamp(1 - distance / s.proximity, 0, 1);
      var near = t * t * (3 - 2 * t);
      var nearest = loopPosition(x, y, halfX, halfY, cornerRadius(s));
      if (distance > 0) return { spot: nearest, near: near };
      var depth = clamp(Math.min(halfX - Math.abs(x), halfY - Math.abs(y)) / (halfY * 0.8), 0, 1);
      var sway = restSpot(s) - (x / halfX) * 0.06 - (y / halfY) * 0.02;
      var offset = sway - nearest - Math.round(sway - nearest);
      return { spot: wrap(nearest + offset * depth * depth * (3 - 2 * depth)), near: near };
    }

    function draw(s) {
      var gl = r.gl, u = r.uniforms;
      if (r.canvas.width !== canvas.width) r.canvas.width = canvas.width;
      if (r.canvas.height !== canvas.height) r.canvas.height = canvas.height;
      var width = view.width, height = view.height;
      var scaleX = canvas.width / (width + PAD * 2);
      var scaleY = canvas.height / (height + PAD * 2);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(r.program);
      gl.uniform2f(u.uCenter, (PAD + width / 2) * scaleX, (PAD + height / 2) * scaleY);
      gl.uniform2f(u.uHalf, (width / 2) * scaleX, (height / 2) * scaleY);
      gl.uniform1f(u.uRadius, Math.min(s.radius, width / 2, height / 2) * scaleX);
      gl.uniform1f(u.uPx, view.ratio);
      var rr = Math.min(s.radius, width / 2, height / 2);
      var rim = rimPoint(state.spot, width / 2, height / 2, rr);
      var len = Math.hypot(rim[0], rim[1]);
      var pull = 1 - Math.min(0.35 * (height / 2), len) / Math.max(len, 0.0001);
      gl.uniform1f(u.uSpot, state.spot);
      gl.uniform2f(u.uEntry, rim[0] * pull * scaleX, rim[1] * pull * scaleY);
      gl.uniform3fv(u.uLineColor, toRgb(s.lineColor));
      gl.uniform3fv(u.uBaseColor, toRgb(s.baseColor));
      gl.uniform1f(u.uIntensity, s.intensity * (state.level + state.press * 0.8));
      gl.uniform2f(u.uWindow, s.shineSize / 360 + state.press * 0.06, s.shineFade / 360 + 0.0001);
      gl.uniform1f(u.uThickness, s.thickness);
      gl.uniform1f(u.uGlow, s.glow);
      gl.bindVertexArray(r.vao);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      gl.bindVertexArray(null);
      // Copia el resultado al canvas propio del botón
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(r.canvas, 0, 0);
    }

    function frame(now) {
      raf = 0;
      if (!visible) return;
      var s = settings;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
      last = now;
      var target = aim(s);
      var spinning = s.autoAnimate && !reduce;
      var steering = !!target && target.near > 0;
      if (!state.ready) {
        state.spot = restSpot(s);
        state.level = s.autoAnimate ? 1 : s.idleIntensity;
        state.ready = true;
      }
      var diff = 0;
      if (spinning && !steering) state.spot = wrap(state.spot + (s.speed / TAU) * dt);
      else {
        diff = (steering ? target.spot : restSpot(s)) - state.spot;
        diff -= Math.round(diff);
        state.spot = wrap(state.spot + diff * (1 - Math.exp(-dt * 8)));
      }
      var level = s.autoAnimate ? 1 : s.idleIntensity + (1 - s.idleIntensity) * (target ? target.near : 0);
      state.level += (level - state.level) * (1 - Math.exp(-dt * 7));
      state.press *= Math.exp(-dt * 5);
      draw(s);
      var settling = Math.abs(diff) > 0.0002 || Math.abs(level - state.level) > 0.001 || state.press > 0.002;
      if (settling || (spinning && !steering)) raf = requestAnimationFrame(frame);
      else last = 0;
    }

    function wake() { if (!raf && visible && button.isConnected) raf = requestAnimationFrame(frame); }

    function measure(entry) {
      var box = entry && entry.borderBoxSize && entry.borderBoxSize[0];
      view.width = Math.max(1, box ? box.inlineSize : button.offsetWidth);
      view.height = Math.max(1, box ? box.blockSize : button.offsetHeight);
      view.ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round((view.width + PAD * 2) * view.ratio));
      canvas.height = Math.max(1, Math.round((view.height + PAD * 2) * view.ratio));
      settings = readSettings(button);
      if (state.ready && visible) draw(settings);
      wake();
    }

    button.addEventListener('pointerdown', function (e) {
      pointer.x = e.clientX; pointer.y = e.clientY; pointer.known = true;
      if (!settings.disabled) state.press = 1;
      wake();
    });
    // Al cambiar de variante (agotado/disponible) o de color al pasar el mouse, se vuelven a leer los ajustes
    button.addEventListener('transitionend', function () { settings = readSettings(button); wake(); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { settings = readSettings(button); wake(); })
        .observe(button, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(function (entries) { measure(entries[entries.length - 1]); }).observe(button);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries.some(function (entry) { return entry.isIntersecting; });
        if (visible) { last = 0; wake(); }
      }, { rootMargin: '50px' }).observe(button);
    } else {
      visible = true;
    }
    instances.push({ wake: wake });
    measure();
  }

  /* ---------- Estilos para los botones del tema ---------- */
  function injectStyles() {
    if (document.getElementById('gym-specular-fx-style')) return;
    var style = document.createElement('style');
    style.id = 'gym-specular-fx-style';
    style.textContent =
      '.gym-specular-fx > .gym-specular__light{position:absolute;inset:-24px;z-index:2;display:block;width:calc(100% + 48px);height:calc(100% + 48px);pointer-events:none;}' +
      '.gym-specular-fx{-webkit-tap-highlight-color:transparent;}';
    document.head.appendChild(style);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var own = scope.querySelectorAll('.gym-specular');
    for (var i = 0; i < own.length; i++) setup(own[i]);
    for (var t = 0; t < AUTO_TARGETS.length; t++) {
      var list = scope.querySelectorAll(AUTO_TARGETS[t].selector);
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        if (el.__gymSpecular) continue;
        if (!el.hasAttribute('data-auto-animate')) el.setAttribute('data-auto-animate', AUTO_TARGETS[t].auto);
        setup(el);
      }
    }
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(document); }, 250);
  }

  function init() {
    injectStyles();
    scan(document);
    // "Comprar ahora" lo dibuja Shopify después, y la compra rápida abre ventanas nuevas: se vigila el DOM
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) { scheduleScan(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // El editor de temas recarga secciones sin recargar la página
  document.addEventListener('shopify:section:load', function () { scan(document); });
})();
